import React, {useState} from "react";
import "tippy.js/dist/tippy.css";
import WithdrawalDetails from "./WithdrawalDetails";
import IconButton from "../../../components/button/IconButton";
import {ButtonGroup} from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const PartListActions = ({part}) => {

    const { t } = useTranslation();
    const [withdrawalDetails, setWithdrawalDetails] = useState();


    return (
        <>
            <ButtonGroup>

                <IconButton variant={"outline-primary"}
                            icon={"fa-trash"}
                            tooltip={t("tooltips.withdrawal_details")}
                            onClick={() => {
                                setWithdrawalDetails(part);
                            }}/>

                {

                    withdrawalDetails &&
                    <WithdrawalDetails
                        part={withdrawalDetails}
                        setPart={setWithdrawalDetails}
                    />
                }
            </ButtonGroup>
        </>
    );
};


export default PartListActions;